import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionsContext';
import Dashboard from './Dashboard';

const TechnikerRedirect = () => {
  const navigate = useNavigate();
  const { isTechniker, loading } = usePermissions();

  useEffect(() => {
    if (!loading && isTechniker()) {
      // Techniker haben kein Dashboard-Zugriff, weiterleiten zur Lagerverwaltung
      navigate('/inventory', { replace: true });
    }
  }, [isTechniker, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Lade Dashboard...</p>
        </div>
      </div>
    );
  }

  if (isTechniker()) {
    // Sollte normalerweise nicht erreicht werden, da useEffect weiterleitet
    return null;
  }

  // Für Admin und Manager: Normales Dashboard anzeigen
  return <Dashboard />;
};

export default TechnikerRedirect;